import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTitleStore = defineStore('title', () => {
  const title = ref('');
  return { title };
});
